import { Typography } from "@mui/material";
import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import './ChartStyles.css'

const QuizChart = ({ qdata }) => {
  const formattedData = qdata.map(item => ({
    name: item.CategoryName.replace(/\s*\([^)]*\)/g, ''),
    TotalQuizzes: item.TotalQuizzes,
    Completed: item.TotalCompletedQuizzes,
    Incomplete: item.TotalQuizzes - item.TotalCompletedQuizzes,
  }));

  return (
    <div>
       <h2 className="chart-title">Graph By Category</h2>
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={formattedData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="TotalQuizzes" fill="#8884d8" />
        <Bar dataKey="Completed" fill="#82ca9d" />
        <Bar dataKey="Incomplete" fill="#ffc658" />
      </BarChart>
    </ResponsiveContainer>
    </div>
  );
};

export default QuizChart;
